import { createSlice } from "@reduxjs/toolkit";
import { STATUS_PROCESS } from "libs/configs/constant";
import { HOME_TAB, SMART_T_STEP } from "libs/constant/Step";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import { getSmartForm } from "redux/modules/visaForm/actions";

let initialState = {
  smartFormStep: "none",
  homeTab: HOME_TAB.EMPLOYEE_LIST,
  employeeListDocTypeTab: null,
  isExtension: false,
  isChange: false,
  isM24: true,
  typeChange: "",
  router: {
    request: [],
  },
  stack: [],
};

const uiSlice = createSlice({
  name: "ui",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
    setSmartFormStep(state, action) {
      state.smartFormStep = action.payload;
      if (state.stack.length === 0 && state.router.request.includes("none")) {
        state.stack.push("none");
      }
      state.stack.push(action.payload);
    },
    setSmartFormBackStep(state, action) {
      if (state.smartFormStep !== "none" && state.stack?.length > 0) {
        // if (state.smartFormStep !== "none") {
        state.stack.pop();
        state.smartFormStep = state.stack[state.stack.length - 1];
      }
    },
    setSmartFormNextStep(state, action) {
      state.stack.push(action.payload);
    },
    setHomeTab(state, action) {
      state.homeTab = action.payload;
    },
    setEmployeeListDocTypeTab(state, action) {
      state.employeeListDocTypeTab = action.payload;
    },
    clearSmartFormStep(state) {
      state.smartFormStep = initialState.smartFormStep;
      state.router = initialState.router;
      state.stack = initialState.stack;
    },
    clearStack(state, action) {
      state.stack = action.payload || [];
    },
    setIsExtension(state, action) {
      state.isExtension = action.payload;
    },
    setIsChange(state, action) {
      state.isChange = action.payload;
    },
    initRouter(state, action) {
      state.router.request = action.payload;
    },
    setTypeChange(state, action) {
      state.typeChange = action.payload;
    },
    setM24(state, action) {
      // state.isM24 = action.payload;
      // isM24
      // if (action.payload) {
      //   state.router.request = [
      //     SMART_T_STEP.NONE,
      //     SMART_T_STEP.INSTITUTION_COMPANY,
      //     SMART_T_STEP.EMPLOYEE_LIST,
      //     SMART_T_STEP.UPLOAD_PASSPORT,
      //     SMART_T_STEP.PART_A_1,
      //     SMART_T_STEP.PART_A_2,
      //     SMART_T_STEP.UPLOAD_DOCUMENT,
      //   ];
      // }
      // if (state.smartFormStep !== "none") {
      //   state.stack = state.router.request.slice(
      //     0,
      //     state.router.request.indexOf(state.smartFormStep)
      //   );
      // }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSmartForm.fulfilled, (state, action) => {
      // state.router = {
      //   request: [],
      // };
      // const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
      // const smartformDetail = get(action.payload, "detail", []).reduce(
      //   smartNameById,
      //   {}
      // );
      // const ConditionType = get(smartformDetail, "ConditionType.value", "");
      // const isGovernment = !(
      //   ConditionType === "Start up" || ConditionType === "Company"
      // );
      // // Request smart form
      // switch (action.payload.smartserviceId) {
      //   case VISA_TYPE_ID.SMART_T: {
      //     if (isGovernment) {
      //       state.router.request = [
      //         SMART_T_STEP.UPLOAD_PASSPORT,
      //         SMART_T_STEP.PART_A_1,
      //         SMART_T_STEP.PART_A_2,
      //         SMART_T_STEP.PART_C,
      //         SMART_T_STEP.UPLOAD_DOCUMENT,
      //         SMART_T_STEP.SURVEY,
      //         // SMART_T_STEP.SUMMARIZE,
      //       ];
      //     } else {
      //       state.router.request = [
      //         SMART_T_STEP.UPLOAD_PASSPORT,
      //         SMART_T_STEP.PART_A_1,
      //         SMART_T_STEP.PART_A_2,
      //         SMART_T_STEP.PART_B,
      //         SMART_T_STEP.PART_C,
      //         SMART_T_STEP.UPLOAD_DOCUMENT,
      //         SMART_T_STEP.SURVEY,
      //         // SMART_T_STEP.SUMMARIZE,
      //       ];
      //     }
      //     break;
      //   }
      //   case VISA_TYPE_ID.SMART_E:
      //     state.router.request = [
      //       SMART_T_STEP.UPLOAD_PASSPORT,
      //       SMART_T_STEP.PART_A_1,
      //       SMART_T_STEP.PART_A_2,
      //       SMART_T_STEP.PART_B,
      //       SMART_T_STEP.PART_C,
      //       SMART_T_STEP.UPLOAD_DOCUMENT,
      //       SMART_T_STEP.SURVEY,
      //       SMART_T_STEP.SUMMARIZE,
      //     ];
      //     break;
      //   case VISA_TYPE_ID.SMART_I:
      //     state.router.request = [
      //       SMART_T_STEP.UPLOAD_PASSPORT,
      //       SMART_T_STEP.PART_A_1,
      //       SMART_T_STEP.PART_A_2,
      //       SMART_T_STEP.PART_B,
      //       SMART_T_STEP.PART_C,
      //       SMART_T_STEP.VISA_INSUANCE,
      //       SMART_T_STEP.UPLOAD_DOCUMENT,
      //       SMART_T_STEP.SURVEY,
      //       SMART_T_STEP.SUMMARIZE,
      //     ];
      //     break;
      //   case VISA_TYPE_ID.SMART_S: {
      //     if (ConditionType === "2Y") {
      //       state.router.request = [
      //         SMART_T_STEP.UPLOAD_PASSPORT,
      //         SMART_T_STEP.PART_A_1,
      //         SMART_T_STEP.PART_A_2,
      //         SMART_T_STEP.PART_D,
      //         SMART_T_STEP.PART_E,
      //         SMART_T_STEP.HEALTH_INSUANCE,
      //         SMART_T_STEP.VISA_INSUANCE,
      //         SMART_T_STEP.UPLOAD_DOCUMENT,
      //         SMART_T_STEP.SURVEY,
      //         SMART_T_STEP.SUMMARIZE,
      //       ];
      //     } else if (ConditionType === "1YA") {
      //       state.router.request = [
      //         SMART_T_STEP.UPLOAD_PASSPORT,
      //         SMART_T_STEP.PART_A_1,
      //         SMART_T_STEP.PART_A_2,
      //         SMART_T_STEP.PART_B,
      //         SMART_T_STEP.PART_E,
      //         SMART_T_STEP.HEALTH_INSUANCE,
      //         SMART_T_STEP.VISA_INSUANCE,
      //         SMART_T_STEP.UPLOAD_DOCUMENT,
      //         SMART_T_STEP.SURVEY,
      //         SMART_T_STEP.SUMMARIZE,
      //       ];
      //     } else if (ConditionType === "1YB") {
      //       state.router.request = [
      //         SMART_T_STEP.UPLOAD_PASSPORT,
      //         SMART_T_STEP.PART_A_1,
      //         SMART_T_STEP.PART_A_2,
      //         SMART_T_STEP.PART_C,
      //         SMART_T_STEP.PART_E,
      //         SMART_T_STEP.HEALTH_INSUANCE,
      //         SMART_T_STEP.VISA_INSUANCE,
      //         SMART_T_STEP.UPLOAD_DOCUMENT,
      //         SMART_T_STEP.SURVEY,
      //         SMART_T_STEP.SUMMARIZE,
      //       ];
      //     } else if (ConditionType === "6M") {
      //       state.router.request = [
      //         SMART_T_STEP.UPLOAD_PASSPORT,
      //         SMART_T_STEP.PART_A_1,
      //         SMART_T_STEP.PART_A_2,
      //         SMART_T_STEP.PART_E,
      //         SMART_T_STEP.HEALTH_INSUANCE,
      //         SMART_T_STEP.VISA_INSUANCE,
      //         SMART_T_STEP.UPLOAD_DOCUMENT,
      //         SMART_T_STEP.SURVEY,
      //         SMART_T_STEP.SUMMARIZE,
      //       ];
      //     }
      //     break;
      //   }
      //   case VISA_TYPE_ID.SMART_O:
      //     state.router.request = [
      //       SMART_T_STEP.UPLOAD_PASSPORT,
      //       SMART_T_STEP.PART_A_1,
      //       SMART_T_STEP.PART_B,
      //       SMART_T_STEP.UPLOAD_DOCUMENT,
      //       SMART_T_STEP.SURVEY,
      //       SMART_T_STEP.SUMMARIZE,
      //     ];
      //     break;
      //   default:
      //     break;
      // }
      // // isExtend
      // if (
      //   action.payload.smartserviceId === "ea67ab08-5953-4453-0830-28ed243a8d38"
      // ) {
      //   switch (action.payload.smartserviceReferId) {
      //     case VISA_TYPE_ID.SMART_T:
      //       state.router.request = [
      //         SMART_T_STEP.NONE,
      //         SMART_T_STEP.PART_A_1,
      //         SMART_T_STEP.PART_B,
      //         SMART_T_STEP.PART_C,
      //         SMART_T_STEP.PART_D,
      //         SMART_T_STEP.UPLOAD_DOCUMENT,
      //       ];
      //       break;
      //     case VISA_TYPE_ID.SMART_E:
      //       state.router.request = [
      //         SMART_T_STEP.NONE,
      //         SMART_T_STEP.PART_A_1,
      //         SMART_T_STEP.PART_B,
      //         SMART_T_STEP.PART_C,
      //         SMART_T_STEP.UPLOAD_DOCUMENT,
      //       ];
      //       break;
      //     case VISA_TYPE_ID.SMART_I:
      //       state.router.request = [
      //         SMART_T_STEP.NONE,
      //         SMART_T_STEP.PART_A_1,
      //         SMART_T_STEP.PART_B,
      //         SMART_T_STEP.PART_C,
      //         SMART_T_STEP.PART_F,
      //         SMART_T_STEP.FROM_A,
      //         SMART_T_STEP.UPLOAD_DOCUMENT,
      //       ];
      //       break;
      //     case VISA_TYPE_ID.SMART_S: {
      //       if (ConditionType === "6MA") {
      //         state.router.request = [
      //           SMART_T_STEP.NONE,
      //           SMART_T_STEP.PART_A_1,
      //           SMART_T_STEP.PART_B,
      //           SMART_T_STEP.PART_E,
      //           SMART_T_STEP.HEALTH_INSUANCE,
      //           SMART_T_STEP.UPLOAD_DOCUMENT,
      //         ];
      //       } else if (ConditionType === "6MB") {
      //         state.router.request = [
      //           SMART_T_STEP.NONE,
      //           SMART_T_STEP.PART_A_1,
      //           SMART_T_STEP.PART_B,
      //           SMART_T_STEP.PART_E,
      //           SMART_T_STEP.HEALTH_INSUANCE,
      //           SMART_T_STEP.UPLOAD_DOCUMENT,
      //         ];
      //       } else if (ConditionType === "1YA") {
      //         state.router.request = [
      //           SMART_T_STEP.NONE,
      //           SMART_T_STEP.PART_A_1,
      //           SMART_T_STEP.PART_B,
      //           SMART_T_STEP.PART_C,
      //           SMART_T_STEP.PART_E,
      //           SMART_T_STEP.HEALTH_INSUANCE,
      //           SMART_T_STEP.UPLOAD_DOCUMENT,
      //         ];
      //       } else if (ConditionType === "1YB") {
      //         state.router.request = [
      //           SMART_T_STEP.NONE,
      //           SMART_T_STEP.PART_A_1,
      //           SMART_T_STEP.PART_B,
      //           SMART_T_STEP.PART_C,
      //           SMART_T_STEP.PART_E,
      //           SMART_T_STEP.HEALTH_INSUANCE,
      //           SMART_T_STEP.UPLOAD_DOCUMENT,
      //         ];
      //       } else if (ConditionType === "2Y") {
      //         state.router.request = [
      //           SMART_T_STEP.NONE,
      //           SMART_T_STEP.PART_A_1,
      //           SMART_T_STEP.PART_B,
      //           SMART_T_STEP.PART_C,
      //           SMART_T_STEP.HEALTH_INSUANCE,
      //           SMART_T_STEP.UPLOAD_DOCUMENT,
      //         ];
      //       }
      //       break;
      //     }
      //     case VISA_TYPE_ID.SMART_O:
      //       state.router.request = [
      //         SMART_T_STEP.NONE,
      //         SMART_T_STEP.PART_A_1,
      //         SMART_T_STEP.PART_B,
      //         SMART_T_STEP.PART_G,
      //         SMART_T_STEP.UPLOAD_DOCUMENT,
      //       ];
      //       break;
      //     default:
      //       break;
      //   }
      // }
      // // isChangeSmart
      // if (action.payload.typeDocSmartFromID === "C") {
      //   switch (action.payload.smartserviceReferId) {
      //     case VISA_TYPE_ID.SMART_T:
      //     case VISA_TYPE_ID.SMART_E:
      //     case VISA_TYPE_ID.SMART_I:
      //     case VISA_TYPE_ID.SMART_S:
      //       // case VISA_TYPE_ID.SMART_O:
      //       state.router.request =
      //         getRouterChangeSmartByConditionType(ConditionType);
      //       // state.smartFormStep = state.router.request[1];
      //       break;
      //     default:
      //       break;
      //   }
      // }
      // department request doc
      if (action.payload.statausID === STATUS_PROCESS.RequestAddDoc) {
        state.router.request = [
          SMART_T_STEP.NONE,
          SMART_T_STEP.UPLOAD_DOCUMENT,
        ];
      }
      // if (state.smartFormStep !== "none") {
      //   state.stack = state.router.request.slice(
      //     0,
      //     state.router.request.indexOf(state.smartFormStep)
      //   );
      // }
    });
  },
});

export const {
  setSmartFormStep,
  setSmartFormBackStep,
  setSmartFormNextStep,
  clearSmartFormStep,
  setHomeTab,
  setIsExtension,
  setIsChange,
  setTypeChange,
  setM24,
  initRouter,
  clearStack,
  setEmployeeListDocTypeTab,
} = uiSlice.actions;

export const selectSmartFormStep = (state) => state.ui.smartFormStep;
export const selectHomeTab = (state) => state.ui.homeTab;
export const selectIsExtension = (state) => state.ui.isExtension;
export const selectIsChange = (state) => state.ui.isChange;
export const selectTypeChange = (state) => state.ui.typeChange;
export const selectIsM24 = (state) => state.ui.isM24;
export const selectEmployeeListDocTypeTab = (state) =>
  state.ui.employeeListDocTypeTab;

export default uiSlice.reducer;
